export default "__VITE_ASSET__Bl98MIJQ__"